import { createInstance } from 'antd-style';
var _createInstance = createInstance({
    customToken: {
      editorPrefix: 'editor'
    }
  }),
  createStyles = _createInstance.createStyles,
  ThemeProvider = _createInstance.ThemeProvider;
export { createGlobalStyle, css, cx, injectGlobal, keyframes, useAntdToken as useToken } from 'antd-style';
export * from "./themes";
export { ThemeProvider, createStyles };